import { type AppState } from 'src/redux/app/app.store'

export const selectIsZoneExpanded = (state: AppState) => state.nav.zoneExpanded
export const selectIsNavOpen = (state: AppState) => state.nav.navOpen
export const selectIsMobileNavOpen = (state: AppState) => state.nav.mobileNavOpen
export const selectIsRepairsExpanded = (state: AppState) => state.nav.repairsExpanded
export const selectIsRidersExpanded = (state: AppState) => state.nav.ridersExpanded
export const selectIsVehiclesExpanded = (state: AppState) => state.nav.vehiclesExpanded
export const selectIsBatteryExpanded = (state: AppState) => state.nav.batteryExpanded
